import React, { useState, useEffect, useRef } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import styled from "styled-components";
import { AnimatePresence } from "framer-motion";
import Sidebar from "./Components/Sidebar";
import HomePage from "./Pages/HomePage";
import AboutPage from "./Pages/AboutPage";
import ResumePage from "./Pages/ResumePage";
import ProjectsPage from "./Pages/ProjectsPage";
import ContactPage from "./Pages/ContactPage";
import RoleDetailPage from "./Pages/RoleDetailPage";
import { Moon, Sun, Menu, X } from "lucide-react";

const App: React.FC = () => {
  const location = useLocation();
  const [theme, setTheme] = useState<string>(() => {
    return localStorage.getItem("theme") || "dark-theme";
  });
  const [navToggle, setNavToggle] = useState(false);
  const sidebarRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (
        sidebarRef.current &&
        !sidebarRef.current.contains(e.target as Node)
      ) {
        setNavToggle(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    localStorage.setItem("theme", theme);
    document.documentElement.className = theme;
  }, [theme]);

  const toggleTheme = () => {
    setTheme((prev) => (prev === "dark-theme" ? "light-theme" : "dark-theme"));
  };

  return (
    <div className="App">
      <div ref={sidebarRef}>
        <Sidebar navToggle={navToggle} />
      </div>

      <div className="light-dark-mode" onClick={toggleTheme}>
        {theme === "dark-theme" ? <Sun size={18} /> : <Moon size={18} />}
      </div>

      <div
        className="ham-burger-menu"
        onClick={() => setNavToggle((prev) => !prev)}
      >
        {navToggle ? <X size={22} /> : <Menu size={22} />}
      </div>

      <MainContentStyled>
        <AnimatePresence exitBeforeEnter>
          <Routes location={location} key={location.pathname}>
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/resume" element={<ResumePage />} />
            <Route path="/projects" element={<ProjectsPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/role/:slug" element={<RoleDetailPage />} />
          </Routes>
        </AnimatePresence>
      </MainContentStyled>
    </div>
  );
};

const MainContentStyled = styled.main`
  position: relative;
  margin-left: 280px;
  min-height: 100vh;

  @media screen and (max-width: 1200px) {
    margin-left: 0;
  }
`;

export default App;
